import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './langauge.component.html',
	styleUrls: ['./langauge.component.css']
})

export class LanguageComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/langauge.component.ts